import React, { useState } from "react";
import "./TabSwitcher.css";

const TabsSwitcher = ({
  activeTab,
  setActiveTab,
  disablePartnershipTab,
  disableSubmerchantTab,
}: any) => {
  return (
    <div className="tabs-wrapper">
      <div className="tabs-container">
        <button
          className={`tab-item ${activeTab === 0 ? "active" : ""}`}
          onClick={() => setActiveTab(0)}
          disabled={disableSubmerchantTab}
        >
          Submerchant
        </button>

        <button
          className={`tab-item ${activeTab === 1 ? "active" : ""}`}
          onClick={() => setActiveTab(1)}
          disabled={disablePartnershipTab}
        >
          Partnership
        </button>
      </div>

      {/* Example conditional rendering */}
      {/* <div className="tab-content">
        {activeTab === "submerchant" && <div>Submerchant Form Content</div>}
        {activeTab === "partnership" && <div>Partnership Form Content</div>}
      </div> */}
    </div>
  );
};

export default TabsSwitcher;
